<template>
    <div class="col-md-12 mx-auto">
        <div class="card mt-12">
            <dashboard-ctrl :componentName="componentName"
                            :showHideButton="showHideButton"
                            :showPinButton="showPinButton"
                            :showResizeIcon="showResizeIcon"
                            :size="size"
                            :headerTitle="titleKey"
                            :componentClass="'card-header bg-primary text-white'"
                            :showHeadful="showHeadful"
                            @hide="hide"
                            @resize="resize"
                            @pinned="pinned"
                            @unpinned="unpinned">
            </dashboard-ctrl>

            <div class="btn-toolbar justify-content-between mb-0 mt-2" role="toolbar">
                <div class="col-w">

                </div>
                <div class="input-group">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <div class="card-body pt-1">
                <app-popup ref="appPopup" :fullscreen="true"></app-popup>

                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError">
                </kendo-datasource>

                <kendo-grid ref="grid"
                            :data-source-ref="'datasource1'"
                            :navigatable="gridOptions.navigatable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :excel="gridOptions.excel"
                            :toolbar="gridOptions.toolbar"
                            :editable="false"
                            :data-bound="dataBound">
                    <kendo-grid-column field="id"
                                       :hidden="!claims.audit.read"
                                       :title="$t('account.log.gridHeaders.id')">
                    </kendo-grid-column>
                    <kendo-grid-column field="auditId"
                                       :hidden="!claims.audit.read"
                                       :title="$t('account.log.gridHeaders.auditId')">
                    </kendo-grid-column>
                    <kendo-grid-column field="username"
                                       :title="$t('account.log.gridHeaders.userName')">
                    </kendo-grid-column>
                    <kendo-grid-column field="description"
                                       :title="$t('account.log.gridHeaders.description')">
                    </kendo-grid-column>
                    <kendo-grid-column field="time"
                                       :format="customDateFormat"
                                       :title="$t('account.log.gridHeaders.time')">
                    </kendo-grid-column>
                    <kendo-grid-column field="controller"
                                        :hidden="!claims.audit.read"
                                       :title="$t('account.log.gridHeaders.controllerName')">
                    </kendo-grid-column>
                    <kendo-grid-column field="actionName"
                                        :hidden="!claims.audit.read"
                                       :title="$t('account.log.gridHeaders.actionName')">
                    </kendo-grid-column>
                    <kendo-grid-column field="actionType"
                                        :hidden="!claims.audit.read"
                                       :title="$t('account.log.gridHeaders.type')">
                    </kendo-grid-column>
                    <kendo-grid-column :template="btnsTemplate"
                                       field="btnsColumn"
                                       :title="$t('actions')"
                                       v-if="showBtns"
                                       :width="150">
                    </kendo-grid-column>
                </kendo-grid>
            </div>

            <JsonFormatter v-model="actionDetails" :show.sync="showActionDetails"
                           :titleKey="'buttons.details.btnText'"
                           @onClose="onActionDetailsClose">
            </JsonFormatter>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip'
    import { mapGetters } from 'vuex'
    import bus from '@/components/sidemenu/event-bus';
    import ControlBtnsTemplate from "@/components/dashboard/ControlBtnsTemplate";
    import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
    import MsgPopup from "@/components/common/MsgPopup.vue";
    import JsonFormatter from "@/components/common/json.formatter.modal.vue";

    export default {
        components: {
            'app-popup': MsgPopup,
            'dashboard-ctrl': ControlBtnsTemplate,
            JsonFormatter
        },
        props: {
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: true,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            all: {
                type: Boolean,
                default: false
            },
            showHeadful: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                componentName: "actionregister", // Used from dashboard controll. Have to be the same as the component name
                titleKey: 'account.logs',
                searchQuery: '',
                defaultGridRows: this.$store.getters.defaultGridRows,
                schemaModelFields: {
                    id: { name: 'id', type: 'number', editable: false, nullable: true, visible: true },
                    auditId: { name: 'auditId', type: 'number', editable: false, nullable: true, visible: true },
                    username: { name: 'username', type: 'string', editable: false, nullable: true, visible: true },
                    description: { name: 'description', type: 'string', editable: false, nullable: true, visible: true },
                    time: { name: 'time', type: 'date', visible: true, titleKey: 'account.audit.gridHeaders.timeAccessedUtc' }
                },
                transportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + `/api/actionLog/${(this.all ? 'all' : 'my')}`,
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                actionDetails: '',
                showActionDetails: false,
            };
        },
        methods: {
            dataBound(e) {

            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration,
                })
            },
            parameterMap(options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) }
                } else {
                    return kendo.stringify(options);
                }
            },
            btnsTemplate(e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        parentComponent: this.$refs.grid,
                        btns: [{
                            name: "details",
                            text: "",
                            tooltip: this.$t('details'),
                            class: 'btn btn-info',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.showDetails
                        },
                        {
                            name: "actionDetails",
                            text: "",
                            tooltip: this.$t('buttons.details.btnText'),
                            class: 'btn btn-info',
                            icon: "fas fa-eye",
                            show: true,
                            clickHandler: this.showActionDetailsModal
                        }]
                    }
                };
            },
            beforeSend(req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            showDetails(args) {
                this.$http.get(`/api/actionLog/${args.id}/data`)
                    .then(response => {
                        var content = this.getDetailsText(response.data)
                        this.$refs.appPopup.show('success', this.$t('details'), content);
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('details'),
                            text: this.$helpers.errorText(error),
                            color: 'success',
                            time: this.$store.getters.notificationDuration,
                        })
                    });
            },
            getDetailsText(data) {
                return "<div class=\"form-group\">"
                    + data.data
                    + "</div>"
                    + "<hr />"
                    + "<div class=\"form-group\">"
                    + data.addData
                    + "</div>"
            },
            onActionLogCreate(userId) {
                if (this.all) {
                    this.refresh();
                } else {
                    if (userId && this.currentUserId === userId) {
                        this.refresh();
                    }
                }
            },
            showActionDetailsModal(args) {
                this.$http.get(`/api/actionLog/${args.id}/data`)
                    .then(response => {
                        this.actionDetails = {
                            data: response.data.data ? JSON.parse(response.data.data) : '',
                            addData: response.data.addData ? JSON.parse(response.data.addData) : ''
                        };
                        this.showActionDetails = true;
                    }).catch(error => {
                        this.$vs.notify({
                            title: this.$t('details'),
                            text: this.$helpers.errorText(error),
                            color: 'error',
                            time: this.$store.getters.notificationDuration,
                        })
                    });
            },
            onActionDetailsClose() {
                this.actionDetails = '';
                this.showActionDetails = false
            },
            refresh() {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            resize(componentName, size) {
                this.$emit('resize', componentName, size)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            hide(componentName) {
                this.$emit('hide', componentName)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            pinned(componentName) {
                this.$emit('pinned', componentName)
            },
            // Трабва на конпонентата за бутоните за дашборд настройките. Предава събитието от компонента с бутоните до началната страница(дашборда)
            unpinned(componentName) {
                this.$emit('unpinned', componentName)
            },
            clearFilters() {
                this.searchQuery = '';
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.sort({});
                    grid.dataSource.page(1);
                    grid.dataSource.aggregate([]);
                    grid.dataSource.filter({});
                }
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
        },
        mounted() {

        },
        created() {
            window.JSZip = JSZip
            this.bus = bus;

            this.bus.$on('action-log-create', this.onActionLogCreate);
        },
        beforeDestroy() {
            // Make sure to cleanup SignalR event handlers when removing the component
            this.bus.$off('action-log-create', this.onActionLogCreate);
        },
        computed: {
            ...mapGetters(['claims', 'authToken', 'dateTimeLongFormat', 'userId']),
            token() {
                return this.authToken;
            },
            customDateFormat() {
                return `{0:${this.dateTimeLongFormat}}`
            },
            currentUserId() {
                return this.userId;
            },
            gridOptions() {
                return {
                    ...this.$store.getters.gridOptions,
                    toolbar: ['excel'],
                    excel: {
                        fileName: `${this.$t(this.titleKey)}.xlsx`,
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    }
                };
            },
        }
    }
</script>

<style scoped>
</style>
